import { useSearchParams } from "react-router-dom";
import DeviceVerificationView from "../components/mcp/device/DeviceVerificationView";
import LoadingIndicator from "../components/shared/LoadingIndicator";
import { useAuth } from "../contexts/AuthContext";
import type { ClientSession } from "../types/auth";

/**
 * DeviceVerificationPage
 *
 * Standalone page for /verify-device route.
 * Handles its own authentication state.
 */
export default function DeviceVerificationPage() {
    const [searchParams] = useSearchParams();
    const userCode = searchParams.get("user_code") || undefined;

    const { user, accessToken, loading } = useAuth();

    // Construct session object expected by DeviceVerificationView
    const session: ClientSession | null = user
        ? {
              user: user,
              access_token: accessToken || "",
          }
        : null;

    if (loading) {
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100vh",
                    fontFamily: "system-ui, sans-serif",
                }}
            >
                <LoadingIndicator />
            </div>
        );
    }

    // Authenticated? Show Device Verification View
    return (
        <DeviceVerificationView
            session={session}
            userCode={userCode}
            onComplete={() => {
                // No redirect or auto-close — the success state tells the user they can
                // close the window. (Auto-close is unreliable for tabs the browser didn't
                // open via script, e.g. the CLI agent opening the browser.) The setup page
                // they came from updates live as the device comes online.
            }}
        />
    );
}
